const MATRIX = {
    Director: ['people:read', 'people:write', 'checklists:read', 'checklists:write', 'settings:checklists', 'documents:read', 'documents:write', 'documents:bulk_import', 'documents:verify', 'accounts:read', 'accounts:lock', 'accounts:settings', 'audit:read'],
    RTOManager: ['people:read', 'people:write', 'checklists:read', 'checklists:write', 'settings:checklists', 'documents:read', 'documents:write', 'documents:bulk_import', 'documents:verify', 'accounts:read', 'accounts:lock', 'audit:read'],
    AdminOfficer: ['people:read', 'checklists:read', 'checklists:write', 'documents:read', 'documents:write', 'accounts:read'],
    Employee: [],
};
export function can(roles, p) {
    return roles.some((r) => MATRIX[r]?.includes(p));
}
export const APP_ROLES = ['Director', 'RTOManager', 'AdminOfficer', 'Employee'];
/**
 * Which checklist owners a role may tick off. Directors and RTO Managers can complete any task,
 * including an automatic (System) task as a manual override when the automation cannot run.
 */
export function canCompleteTask(roles, owner, isOwnRun) {
    if (roles.includes('Director') || roles.includes('RTOManager'))
        return true;
    if (owner === 'System')
        return false;
    if (roles.includes('AdminOfficer') && ['Admin Officer', 'Payroll'].includes(owner))
        return true;
    return isOwnRun && (owner === 'New starter' || owner === 'Leaver');
}
//# sourceMappingURL=roles.js.map